import type { Intervention } from '@seen/core/models/care-plans/intervention'
import { interventionName } from '@seen/core/models/care-plans/interventionName'
import { truncate } from 'lodash-es'
import { browserNoteText } from '#src/utils/noteDisplay.ts'

/* A picker row and a mention chip both need one line, and a care plan is
 * written in paragraphs. Inclusive of the ellipsis, as lodash counts it. */
const MAX_LABEL_LENGTH = 121

/* The intervention's name, cut to a chip's worth.
 *
 * The naming rule itself is `interventionName` in `@seen/core`, shared with
 * every surface that names an intervention; this supplies the browser's readers
 * and the length only this surface cares about. Same split as `getNoteName`. */
export function interventionLabel(intervention: Intervention): string {
  return truncate(interventionName(intervention, browserNoteText), {
    length: MAX_LABEL_LENGTH,
    omission: '…',
  })
}
